<rsValidForm #form="rsValidForm" [rsValidOnceInteracted]="true">
  <div class="inputs">
    <div class="field">
      <div class="label">Initial Water Use</div>
      <div class="input">
        <mat-form-field [floatLabel]="'always'" appearance="fill">
          <mat-label>Water Use</mat-label>
          <input matInput [(ngModel)]="input.preInput" placeholder="Water use" type="number" rsValid="greaterZero" />
          <strong matSuffix>ML/ha</strong>
        </mat-form-field>
      </div>
    </div>
    <div class="field">
      <div class="label">Area Applied</div>
      <div class="input">
        <mat-form-field [floatLabel]="'always'" appearance="fill">
          <mat-label>Area</mat-label>
          <input matInput [(ngModel)]="input.areaOfUse" placeholder="Area" type="number" rsValid="greaterZero" />
          <strong matSuffix>ha</strong>
        </mat-form-field>
      </div>
    </div>

    <div class="field">
      <div class="label">Initial Water Use Applied</div>
      <div class="input">
        <mat-form-field [floatLabel]="'always'" appearance="fill" class="calculated">
          <mat-label>Water Applied</mat-label>
          <input matInput [value]="input.preUse | number:'1.0-2'" readonly placeholder="Water Applied" />
          <strong matSuffix>ML</strong>
        </mat-form-field>
      </div>
    </div>

    <div class="field">
      <div class="label">Post Practice change Water Use</div>
      <div class="input">
        <mat-form-field [floatLabel]="'always'" appearance="fill">
          <mat-label>Post Water Use</mat-label>
          <input matInput [(ngModel)]="input.postInput" placeholder="Water use" type="number" rsValid="greaterZero" />
          <strong matSuffix>ML/ha</strong>
        </mat-form-field>
      </div>
    </div>

    <div class="field">
      <div class="label">Water Use Saving</div>
      <div class="input">
        <mat-form-field [floatLabel]="'always'" appearance="fill" class="calculated">
          <mat-label>Water Saving</mat-label>
          <input matInput [value]="input.reductionAmount | number:'1.0-2'" readonly placeholder="Water Saving" />
          <strong matSuffix>ML</strong>
        </mat-form-field>
      </div>
    </div>

    <div class="field">
      <div class="label">Productivity Change Improvement</div>
      <div class="input">
        <mat-form-field [floatLabel]="'always'" appearance="fill">
          <mat-label>Productivity Change</mat-label>
          <input matInput [(ngModel)]="input.postProductivityImprove" placeholder="Productivity Change" type="number" rsValid="greaterEqualZero" />
          <strong matSuffix>kg/ha</strong>
        </mat-form-field>
      </div>
    </div>

    <div class="field">
      <div class="label">Input Change Saving</div>
      <div class="input">
        <mat-form-field [floatLabel]="'always'" appearance="fill">
          <mat-label>Input Change</mat-label>
          <input matInput [(ngModel)]="input.postInputChange" placeholder="Input Change" type="number" rsValid="greaterEqualZero" />
          <strong matSuffix>$/ha</strong>
        </mat-form-field>
      </div>
    </div>

  </div>
</rsValidForm>
<br/>
<ng-template #actionButtons>

  <button mat-button (click)="this.dialogHandles.close(false)">
    Cancel
  </button>

  <button color="primary" mat-button (click)="save()">
    <mat-icon>save</mat-icon> Save
  </button>

</ng-template>
